// TODO create composable with stuff like isFetching, error, defaultParams, ...
import useConfig from "@/composables/config";
const { config } = useConfig();
export interface ServerError {
  statusCode: number;
  errorCode?: number;
  errorMsg?: string;
}

export type SearchEndpoint =
  | "persons"
  | "institutions"
  | "projects"
  | "publications"
  | "activities"
  | "users"
  | "ddcs"
  | "keywords";

export type CreateEndpoint =
  | "activity/create"
  | "person/create"
  | "project/create"
  | "institution/create";

export type OtherEndpoint =
  | "uploadTempFile"
  | "reportsInstitution"
  | "reportsPerson"
  | "file/createPreviewImageFromPDF"
  | "file/deletePreviewImage"
  | "file/updatePreviewImage"
  | "tan/generateLopesTan"
  | "tan/deleteLopesTan"
  | "document/insertIssueDate"
  | "document/registerDOI"
  | "document/generateURN"
  | "connectGND/getDissInfo"
  | "connectGND/SearchGNDPerson"
  | "connectGND/createGNDPerson"
  | "connectGND/UpdateGNDPerson";

// TODO add and use "mergePersons"

export type EndPoint = SearchEndpoint | CreateEndpoint | OtherEndpoint;

// TODO determine GET/POST and url from endpoint
export async function fetchFromBackendGet(
  endpoint: EndPoint,
  params: Record<string, any>,
  url: string = config.apiPath,
  type: "json" | "text" = "json"
) {
  return fetchFromBackend(endpoint, params, "GET", undefined, url, type);
}

// TODO config.backendPath will phase out, should change to config.apiPath at some point
// TODO support FormData for file upload
export async function fetchFromBackendPost(
  endpoint: EndPoint,
  postData: Record<string, any> | undefined,
  url: string = config.backendPath,
  type: "json" | "text" = "json"
) {
  return fetchFromBackend(endpoint, undefined, "POST", postData, url, type);
}

async function fetchFromBackend(
  endpoint: EndPoint,
  params: Record<string, any> | undefined,
  method: "GET" | "POST" = "GET",
  postData: Record<string, any> | undefined = undefined,
  url: string,
  type: "json" | "text" = "json"
) {
  const p = new URLSearchParams(params);
  const query = `${url}/${endpoint}?${p.toString()}`;
  const init =
    method === "POST"
      ? {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify(postData),
        }
      : undefined;
  const res = await fetch(query, init);
  if (!res.ok) {
    const errObj: ServerError = {
      statusCode: res.status,
      errorMsg: "Unknown error",
    };
    try {
      const resBody = await (type === "json" ? res.json() : res.text());
      if (resBody && resBody.errorMsg) {
        errObj.errorMsg = resBody.errorMsg;
        errObj.errorCode = resBody.errorCode ?? null;
      }
    } catch (error) {
      errObj.errorMsg += ", might be unknown because of yiic debug-mode";
    }
    throw errObj;
  }
  const data = await (type === "json" ? res.json() : res.text());
  return data;
}
